import { createThread } from '@/services/chat/threadsApi'

import { uploadThreadSources } from './uploadThreadSources.js'

export function attachmentsUnsupportedResult() {
  return {
    ok: false,
    code: 'ATTACHMENTS_UNSUPPORTED',
    message: 'File attachments are only supported by the Hermes chat endpoint right now.',
  }
}

function titleFromMessages(messages, files) {
  const latestUser = Array.isArray(messages)
    ? [...messages].reverse().find((message) => message?.role === 'user')
    : null
  const text = String(latestUser?.content || files?.[0]?.name || 'Attachment').split('\n')[0].trim()
  if (!text) return 'New chat'
  return text.length <= 56 ? text : `${text.slice(0, 56)}...`
}

export async function resolveChatSourceIds({ threadId, files, sourceIds, messages, signal }) {
  const explicitSourceIds = Array.isArray(sourceIds) ? sourceIds.filter(Boolean) : []
  if (!Array.isArray(files) || files.length === 0) return { ok: true, sourceIds: explicitSourceIds }
  await createThread({ id: threadId, title: titleFromMessages(messages, files), signal })
  const upload = await uploadThreadSources({ threadId, files, signal })
  if (!upload.ok) return upload
  return { ok: true, sourceIds: [...explicitSourceIds, ...(upload.sourceIds || [])] }
}
